import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { red } from "@material-ui/core/colors";
import { likeImg, dislikeImg } from "../constants/assets";
import { useState } from "react";
import { useEffect } from "react";
import HexHover from "../../../components/HexHover";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 345,
    margin: 10,
    height: 650,
    position: "relative",
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
  action: {
    marginTop: 0,
  },
  title: {
    fontSize: 23,
    fontFamily: "Baskervville",
    lineHeight: "1.3",
  },
  paragraph: {
    fontFamily: "Baskervville",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 4,
    display: "-webkit-box",
    overflow: "hidden",
  },
  actions: {
    position: "absolute",
    width: "100%",
    bottom: "5px",
    display: "flex",
    flexDirection: "column",
  },
  bottomText: {
    position: "absolute",
    bottom: "90px",
  },
  subTitle: {
    fontSize: 20,
    fontFamily: "Baskervville",
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  avatar: {
    backgroundColor: red[500],
  },
  like: {
    width: 40,
    height: 40,
    backgroundImage: `url(${likeImg})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },
  dislike: {
    width: 40,
    height: 40,
    backgroundImage: `url(${dislikeImg})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },
}));
const LikeComponent = ({ count = 0 }) => {
  const classes = useStyles();
  return (
    <div className={classes.like}>
      <p>{count}</p>
    </div>
  );
};
const DislikeComponent = ({ count = 0 }) => {
  const classes = useStyles();
  return (
    <div className={classes.dislike}>
      <p>{count}</p>
    </div>
  );
};
const CountPan = ({ shares = 0, reads = 0 }) => {
  return (
    <p>
      {ReactHtmlParser(
        `${shares} <b>shares</b>&nbsp;&nbsp;&nbsp;${reads} <b>reads</b>`
      )}
    </p>
  );
};

export default function ArticleCard({
  content,
  brandName,
  onEdit,
  onShare,
  onCopyLink,
  hex,
  white,
  id,
  removeArticle,
}) {
  const classes = useStyles();
  const [publishForText, setPublishForText] = useState("");
  const HexButton = HexHover("button", hex);

  useEffect(() => {
    if (content.toMembers === undefined || content.toMembers === true) {
      if (content.toReferrals === undefined || content.toReferrals === true) {
        setPublishForText("Published for customers and prospects.");
      } else {
        setPublishForText("Published for customers.");
      }
    } else {
      if (content.toReferrals === undefined || content.toReferrals === true) {
        setPublishForText("Published for prospects.");
      }
    }
  }, [content]);

  return (
    <Card className={classes.root} key={content.id}>
      <CardHeader
        classes={{
          action: classes.action, // class name, e.g. `classes-nesting-root-x`
        }}
        avatar={
          <Avatar
            aria-label="recipe"
            className={classes.avatar}
            style={{
              backgroundColor: hex ? hex : "white",
              color: white ? "white" : "black",
            }}
          >
            {content.username.charAt(0)}
          </Avatar>
        }
        action={
          content.type === "super" ? null : (
            <div style={{ display: "flex" }}>
              <div className="article-delete" onClick={removeArticle}></div>
              <button
                className="btn btn-light btn-brand-hex"
                style={{
                  "--hover-color": hex ? hex : "white",
                  "--hover-text-color": white ? "white" : "black",
                  backgroundColor: "white",
                  color: "black",
                }}
                data-toggle="modal"
                data-target="#edit_article_modal"
                onClick={onEdit}
              >
                Edit
              </button>
            </div>
          )
        }
        title={content.username}
        subheader={new Date(content.time).toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        })}
      />
      <CardContent>
        <Typography color="textPrimary" className={classes.title}>
          {content.title}
        </Typography>
      </CardContent>
      <CardMedia className={classes.media} image={`${content.leadMedia})`} />
      <CardContent>
        <Typography paragraph color="textPrimary" className={classes.paragraph}>
          {content.leadParagraph}
        </Typography>
      </CardContent>
      {/* <CardActions>
        <IconButton aria-label="add to favorites">
          <LikeComponent />
        </IconButton>
        <IconButton aria-label="share">
          <DislikeComponent />
        </IconButton>
        <CountPan shares={content.shares} reads={content.reads} />
      </CardActions> */}
      <CardContent className={classes.bottomText}>
        <Typography>{publishForText}</Typography>
      </CardContent>
      <CardActions className={classes.actions}>
        {content.type === "super" ? null : (
          <div style={{ display: "flex", width: "100%", marginBottom: "10px" }}>
            <Link
              to={{
                pathname: `http://ecosystem.club/${brandName
                  .replace(/\s/g, "")
                  .toLowerCase()}/articles/${id}`,
              }}
              target="_blank"
              className="w-100"
              style={{ marginRight: "5px" }}
            >
              <button
                className="btn btn-brand-hex w-100"
                style={{
                  "--hover-color": hex ? hex : "white",
                  "--hover-text-color": white ? "white" : "black",
                  backgroundColor: "white",
                  color: "black",
                }}
              >
                View
              </button>
            </Link>
            <button
              className="btn btn-brand-hex w-100"
              style={{
                "--hover-color": hex ? hex : "white",
                "--hover-text-color": white ? "white" : "black",
                backgroundColor: "white",
                color: "black",
                marginLeft: "5px",
              }}
              onClick={onShare}
            >
              Share
            </button>
          </div>
        )}
        <button
          className="btn btn-brand-hex w-100"
          style={{
            "--hover-color": hex ? hex : "white",
            "--hover-text-color": white ? "white" : "black",
            backgroundColor: "white",
            color: "black",
            marginLeft: "0px",
          }}
          onClick={onCopyLink}
        >
          Copy the link to this open article
        </button>
      </CardActions>
    </Card>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Articles/components/ArticleCard.js